// assets
import {
  SendOutlined,
  ScheduleOutlined,
  SettingOutlined,
  MessageOutlined,
  ClockCircleOutlined,
} from '@ant-design/icons';


// icons
const icons = {
  SendOutlined,
  ScheduleOutlined,
  SettingOutlined,
  MessageOutlined,
  ClockCircleOutlined,
};

// ==============================|| MENU ITEMS - GROCERY MANAGEMENT ||============================== //

const grocery = {
  id: 'group-grocery',
  title: 'MANAGEMENT',
  type: 'group',
  children: [
    {
      id: 'send-update',
      title: 'WhatsApp Alerts',
      type: 'item',
      url: '/send-update',
      icon: icons.MessageOutlined,
      breadcrumbs: false
    },
    {
      id: 'preferred-time',
      title: 'Delivery Time',
      type: 'item',
      url: '/preferred-time',
      icon: icons.ClockCircleOutlined,
      breadcrumbs: false
    },
    {
      id: 'Setting',
      title: 'Settings',
      type: 'item',
      url: '/settings',
      icon: icons.SettingOutlined,
      breadcrumbs: false
    }
  
  ]
};

export default grocery;
